import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { ArrowLeftRight, ArrowUpDown } from 'lucide-react';

import CommonSlider from '../../../components/common-slider/CommonSlider';
import { DEFAULT_LETTER_SPACING, DEFAULT_LINE_HEIGHT } from '../../core/documentSchema';
import { getBlockStyle } from '../../elements/text/textRuns';

import scss from './TextToolbar.module.scss';

function SpacingMenu({ element, text }) {
  const { t } = useTranslation('mediaStudio');
  const fontSize = getBlockStyle(element).fontSize;
  const letterMax = Math.max(20, Math.round(fontSize * 0.5));
  const mixedLineHeight = text.isMixed(element.lineHeight);
  const mixedLetterSpacing = text.isMixed(element.letterSpacing);
  const lineHeightReset = Math.round(DEFAULT_LINE_HEIGHT * 100);

  return (
    <div className={clsx(scss.menu, scss.panelMenu)}>
      <CommonSlider
        label={t('lineHeight')}
        icon={ArrowUpDown}
        min={50}
        max={300}
        value={mixedLineHeight ? lineHeightReset : Math.round(element.lineHeight * 100)}
        resetValue={lineHeightReset}
        resetLabel={t('resetSlider')}
        valueFormatter={mixedLineHeight ? () => t('mixed') : (value) => `${value}%`}
        onChange={(value) => text.updateBlock({ lineHeight: value / 100 }, { live: true })}
        onCommit={text.endGesture}
      />
      <CommonSlider
        label={t('letterSpacing')}
        icon={ArrowLeftRight}
        min={-Math.round(letterMax / 4)}
        max={letterMax}
        value={mixedLetterSpacing ? DEFAULT_LETTER_SPACING : Math.round(element.letterSpacing)}
        resetValue={DEFAULT_LETTER_SPACING}
        resetLabel={t('resetSlider')}
        valueFormatter={mixedLetterSpacing ? () => t('mixed') : undefined}
        onChange={(letterSpacing) => text.updateBlock({ letterSpacing }, { live: true })}
        onCommit={text.endGesture}
      />
    </div>
  );
}

export default SpacingMenu;
